@if (componentData?.children) {
  <ul class="faq-nav-links">
    @for (data of (data$ | async)?.children; track data; let i = $index) {
      <li class="side-nav-menu">
        <a [routerLink]="data.url"
          routerLinkActive="active"
          [ngClass]="{'active-link': isActive(data.url)}"
          rel="noopener"
          class="cstm-anchor-primary">
          {{data?.title}}
        </a>
      </li>
    }
  </ul>
}

<!-- Old Implementation
<div *ngIf="links$ | async as links" class="sidebar">
  <ng-container *ngFor="let link of links">
    <ul>
      <li class="d-inline-flex sidenav-align">
        <a class="f-14 nav-link" routerLinkActive="active" [ngClass]="{'prod': link.value.name === 'Products'}"
        routerLink="{{link.value.url}}">{{link.value.name}}</a>
      </li>
    </ul>
  </ng-container>
</div> -->